import React from 'react';

import Chart from "./Chart";
import {api} from "./baseFunctions";

class ChartMaker extends React.Component {
	constructor(props){
		super(props);
		this.getData = this.getData.bind(this);
		this.configs = {
				"ObsTypes": {
					"req": {"type": "getObsStats"},
					"title": "Observation typer",
					labelFunc: (data, keys) => Object.keys(data),
					dataFunc: (data, keys) => {
						let test = keys.filter((d) => Object.keys(data).indexOf(keys[d]) === -1).map((d, key) => {
                  return {
                    name: keys[key],
                    data: Object.keys(data).map((typeI) => {
                      const VALUE = data[typeI][keys[key]];
                      return VALUE ? VALUE : null;
                    })
                  };
                });
						return test;
					}
				},
				"RAline": {
					"req": {},
					"title": "Observation typer",
					labelFunc: (data, keys) => data.filter((d) => d.points > 0).map((d) => {
						return {}
					}),
					dataFunc: (data, keys) => Object.keys(keys).filter((d) => Object.keys(data).indexOf(keys[d]) === -1).map((d) => {
                  return {
                    name: keys[d],
                    data: Object.keys(data).map((typeI) => {
                      const VALUE = data[typeI][keys[d]];
                      return VALUE ? VALUE : null;
                    })
                  };
                })
				},
			};
		this.state = {
			dataKeys: [],
			data: props.data ? props.data : [],
		};
	}
	componentDidMount(){
		if(!this.props.data)
		{
			this.getData();
		}
	}
	getData(){
		const CONFIG = this.configs[this.props.type];
		if(!this.props.type || !CONFIG)
		{
			return null;
		}
		api("POST", CONFIG.req, (d) => {
			console.log("daaaaa", d);
			const NEW_STATE = {};
			if(d.keys)
			{
				NEW_STATE.dataKeys = d.keys;
			}
			NEW_STATE.data = d.data;
			console.log("ChartMake", NEW_STATE);
			this.setState(NEW_STATE);
		}, this.props.auth, 1);
	}
	render(){
		const CONFIG = this.configs[this.props.type];
		if(this.props.show === false || !this.props.type || !CONFIG)
		{
			return null;
		}
		return (<Chart
                key={this.state.dataKeys.length}
                title={CONFIG.title}
                hideLegend={this.props.hideLegend}
                labels={CONFIG.labelFunc(this.state.data, this.state.dataKeys)}
                data={CONFIG.dataFunc(this.state.data, this.state.dataKeys)}
              />);
	}
}

export default ChartMaker;


// WEBPACK FOOTER //
// ./src/components/ChartMaker.js